import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=70ca135a"
import script from "./DoctorList.vue?vue&type=script&lang=js"
export * from "./DoctorList.vue?vue&type=script&lang=js"
import style0 from "./DoctorList.vue?vue&type=style&index=0&id=70ca135a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports